import React from 'react'
import { parsePhoneNumberFromString } from 'libphonenumber-js';

function FormatNumber({number}) {

    const formatNumber = (input) => {
        const phoneNumber = parsePhoneNumberFromString(input);
        if (phoneNumber) {
          return phoneNumber.formatInternational();
        }
        return input;
      };

  return (
    <span>{formatNumber(number)}</span>
  )
}

export default FormatNumber